module.exports = __webpack_public_path__ + "img/d76981da38482afb809a13b737f20c20ee7c1137.b587a90a.png";